/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedOrganizationIndexRouteImport } from './routes/_authenticated/organization/index'
import { Route as AuthenticatedNotificationsIndexRouteImport } from './routes/_authenticated/notifications/index'
import { Route as AuthenticatedKnowledgeBaseIndexRouteImport } from './routes/_authenticated/knowledge-base/index'
import { Route as AuthenticatedFinanceIndexRouteImport } from './routes/_authenticated/finance/index'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as AuthenticatedSettingsNotificationsRouteImport } from './routes/_authenticated/settings/notifications'
import { Route as AuthenticatedSettingsMyNotificationsRouteImport } from './routes/_authenticated/settings/my-notifications'
import { Route as AuthenticatedSettingsEfficiencyRouteImport } from './routes/_authenticated/settings/efficiency'
import { Route as AuthenticatedSettingsConfigRouteImport } from './routes/_authenticated/settings/config'
import { Route as AuthenticatedSettingsAuditLogsRouteImport } from './routes/_authenticated/settings/audit-logs'
import { Route as AuthenticatedPmWorkloadStatsRouteImport } from './routes/_authenticated/pm/workload-stats'
import { Route as AuthenticatedPmWorkflowAnalyticsRouteImport } from './routes/_authenticated/pm/workflow-analytics'
import { Route as AuthenticatedPmMyWorkflowTasksRouteImport } from './routes/_authenticated/pm/my-workflow-tasks'
import { Route as AuthenticatedPmMyTasksRouteImport } from './routes/_authenticated/pm/my-tasks'
import { Route as AuthenticatedPmMyStageTasksRouteImport } from './routes/_authenticated/pm/my-stage-tasks'
import { Route as AuthenticatedMyDevicesRouteImport } from './routes/_authenticated/my/devices'
import { Route as AuthenticatedKnowledgeBaseSearchRouteImport } from './routes/_authenticated/knowledge-base/search'
import { Route as AuthenticatedFinanceTransfersRouteImport } from './routes/_authenticated/finance/transfers'
import { Route as AuthenticatedFinanceCurrenciesRouteImport } from './routes/_authenticated/finance/currencies'
import { Route as AuthenticatedPmTimelogsIndexRouteImport } from './routes/_authenticated/pm/timelogs/index'
import { Route as AuthenticatedPmTeamsIndexRouteImport } from './routes/_authenticated/pm/teams/index'
import { Route as AuthenticatedPmProjectsIndexRouteImport } from './routes/_authenticated/pm/projects/index'
import { Route as AuthenticatedPmIssuesIndexRouteImport } from './routes/_authenticated/pm/issues/index'
import { Route as AuthenticatedHrSalariesIndexRouteImport } from './routes/_authenticated/hr/salaries/index'
import { Route as AuthenticatedHrPositionsIndexRouteImport } from './routes/_authenticated/hr/positions/index'
import { Route as AuthenticatedHrLeavesIndexRouteImport } from './routes/_authenticated/hr/leaves/index'
import { Route as AuthenticatedHrEmployeesIndexRouteImport } from './routes/_authenticated/hr/employees/index'
import { Route as AuthenticatedHrDepartmentsIndexRouteImport } from './routes/_authenticated/hr/departments/index'
import { Route as AuthenticatedFinanceReimbursementsIndexRouteImport } from './routes/_authenticated/finance/reimbursements/index'
import { Route as AuthenticatedFinanceCategoriesIndexRouteImport } from './routes/_authenticated/finance/categories/index'
import { Route as AuthenticatedFinanceCashFlowsIndexRouteImport } from './routes/_authenticated/finance/cash-flows/index'
import { Route as AuthenticatedFinanceAccountsIndexRouteImport } from './routes/_authenticated/finance/accounts/index'
import { Route as AuthenticatedAdminDevicesIndexRouteImport } from './routes/_authenticated/admin/devices/index'
import { Route as AuthenticatedPmProjectsNewRouteImport } from './routes/_authenticated/pm/projects/new'
import { Route as AuthenticatedPmIssuesIssueIdRouteImport } from './routes/_authenticated/pm/issues/$issueId'
import { Route as AuthenticatedKnowledgeBaseSpacesSpaceIdRouteImport } from './routes/_authenticated/knowledge-base/spaces.$spaceId'
import { Route as AuthenticatedKnowledgeBaseDocumentsDocumentIdRouteImport } from './routes/_authenticated/knowledge-base/documents.$documentId'
import { Route as AuthenticatedHrSalariesPayslipsRouteImport } from './routes/_authenticated/hr/salaries/payslips'
import { Route as AuthenticatedHrSalariesMyPayslipsRouteImport } from './routes/_authenticated/hr/salaries/my-payslips'
import { Route as AuthenticatedHrLeavesStatisticsRouteImport } from './routes/_authenticated/hr/leaves/statistics'
import { Route as AuthenticatedHrLeavesPendingRouteImport } from './routes/_authenticated/hr/leaves/pending'
import { Route as AuthenticatedHrEmployeesEmployeeIdRouteImport } from './routes/_authenticated/hr/employees/$employeeId'
import { Route as AuthenticatedPmTeamsTeamIdIndexRouteImport } from './routes/_authenticated/pm/teams/$teamId/index'
import { Route as AuthenticatedPmProjectsProjectIdIndexRouteImport } from './routes/_authenticated/pm/projects/$projectId/index'
import { Route as AuthenticatedPmProjectsProjectIdMilestonesRouteImport } from './routes/_authenticated/pm/projects/$projectId/milestones'
import { Route as AuthenticatedPmProjectsProjectIdMembersRouteImport } from './routes/_authenticated/pm/projects/$projectId/members'
import { Route as AuthenticatedPmProjectsProjectIdGanttRouteImport } from './routes/_authenticated/pm/projects/$projectId/gantt'
import { Route as AuthenticatedPmProjectsProjectIdBoardRouteImport } from './routes/_authenticated/pm/projects/$projectId/board'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedOrganizationIndexRoute =
  AuthenticatedOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsIndexRoute =
  AuthenticatedNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseIndexRoute =
  AuthenticatedKnowledgeBaseIndexRouteImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceIndexRoute =
  AuthenticatedFinanceIndexRouteImport.update({
    id: '/finance/',
    path: '/finance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsNotificationsRoute =
  AuthenticatedSettingsNotificationsRouteImport.update({
    id: '/settings/notifications',
    path: '/settings/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsMyNotificationsRoute =
  AuthenticatedSettingsMyNotificationsRouteImport.update({
    id: '/settings/my-notifications',
    path: '/settings/my-notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsEfficiencyRoute =
  AuthenticatedSettingsEfficiencyRouteImport.update({
    id: '/settings/efficiency',
    path: '/settings/efficiency',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsConfigRoute =
  AuthenticatedSettingsConfigRouteImport.update({
    id: '/settings/config',
    path: '/settings/config',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsAuditLogsRoute =
  AuthenticatedSettingsAuditLogsRouteImport.update({
    id: '/settings/audit-logs',
    path: '/settings/audit-logs',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmWorkloadStatsRoute =
  AuthenticatedPmWorkloadStatsRouteImport.update({
    id: '/pm/workload-stats',
    path: '/pm/workload-stats',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmWorkflowAnalyticsRoute =
  AuthenticatedPmWorkflowAnalyticsRouteImport.update({
    id: '/pm/workflow-analytics',
    path: '/pm/workflow-analytics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmMyWorkflowTasksRoute =
  AuthenticatedPmMyWorkflowTasksRouteImport.update({
    id: '/pm/my-workflow-tasks',
    path: '/pm/my-workflow-tasks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmMyTasksRoute = AuthenticatedPmMyTasksRouteImport.update({
  id: '/pm/my-tasks',
  path: '/pm/my-tasks',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPmMyStageTasksRoute =
  AuthenticatedPmMyStageTasksRouteImport.update({
    id: '/pm/my-stage-tasks',
    path: '/pm/my-stage-tasks',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyDevicesRoute = AuthenticatedMyDevicesRouteImport.update({
  id: '/my/devices',
  path: '/my/devices',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKnowledgeBaseSearchRoute =
  AuthenticatedKnowledgeBaseSearchRouteImport.update({
    id: '/knowledge-base/search',
    path: '/knowledge-base/search',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceTransfersRoute =
  AuthenticatedFinanceTransfersRouteImport.update({
    id: '/finance/transfers',
    path: '/finance/transfers',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceCurrenciesRoute =
  AuthenticatedFinanceCurrenciesRouteImport.update({
    id: '/finance/currencies',
    path: '/finance/currencies',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmTimelogsIndexRoute =
  AuthenticatedPmTimelogsIndexRouteImport.update({
    id: '/pm/timelogs/',
    path: '/pm/timelogs/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmTeamsIndexRoute =
  AuthenticatedPmTeamsIndexRouteImport.update({
    id: '/pm/teams/',
    path: '/pm/teams/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsIndexRoute =
  AuthenticatedPmProjectsIndexRouteImport.update({
    id: '/pm/projects/',
    path: '/pm/projects/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmIssuesIndexRoute =
  AuthenticatedPmIssuesIndexRouteImport.update({
    id: '/pm/issues/',
    path: '/pm/issues/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrSalariesIndexRoute =
  AuthenticatedHrSalariesIndexRouteImport.update({
    id: '/hr/salaries/',
    path: '/hr/salaries/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrPositionsIndexRoute =
  AuthenticatedHrPositionsIndexRouteImport.update({
    id: '/hr/positions/',
    path: '/hr/positions/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrLeavesIndexRoute =
  AuthenticatedHrLeavesIndexRouteImport.update({
    id: '/hr/leaves/',
    path: '/hr/leaves/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrEmployeesIndexRoute =
  AuthenticatedHrEmployeesIndexRouteImport.update({
    id: '/hr/employees/',
    path: '/hr/employees/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrDepartmentsIndexRoute =
  AuthenticatedHrDepartmentsIndexRouteImport.update({
    id: '/hr/departments/',
    path: '/hr/departments/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceReimbursementsIndexRoute =
  AuthenticatedFinanceReimbursementsIndexRouteImport.update({
    id: '/finance/reimbursements/',
    path: '/finance/reimbursements/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceCategoriesIndexRoute =
  AuthenticatedFinanceCategoriesIndexRouteImport.update({
    id: '/finance/categories/',
    path: '/finance/categories/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceCashFlowsIndexRoute =
  AuthenticatedFinanceCashFlowsIndexRouteImport.update({
    id: '/finance/cash-flows/',
    path: '/finance/cash-flows/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceAccountsIndexRoute =
  AuthenticatedFinanceAccountsIndexRouteImport.update({
    id: '/finance/accounts/',
    path: '/finance/accounts/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAdminDevicesIndexRoute =
  AuthenticatedAdminDevicesIndexRouteImport.update({
    id: '/admin/devices/',
    path: '/admin/devices/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsNewRoute =
  AuthenticatedPmProjectsNewRouteImport.update({
    id: '/pm/projects/new',
    path: '/pm/projects/new',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmIssuesIssueIdRoute =
  AuthenticatedPmIssuesIssueIdRouteImport.update({
    id: '/pm/issues/$issueId',
    path: '/pm/issues/$issueId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseSpacesSpaceIdRoute =
  AuthenticatedKnowledgeBaseSpacesSpaceIdRouteImport.update({
    id: '/knowledge-base/spaces/$spaceId',
    path: '/knowledge-base/spaces/$spaceId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute =
  AuthenticatedKnowledgeBaseDocumentsDocumentIdRouteImport.update({
    id: '/knowledge-base/documents/$documentId',
    path: '/knowledge-base/documents/$documentId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrSalariesPayslipsRoute =
  AuthenticatedHrSalariesPayslipsRouteImport.update({
    id: '/hr/salaries/payslips',
    path: '/hr/salaries/payslips',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrSalariesMyPayslipsRoute =
  AuthenticatedHrSalariesMyPayslipsRouteImport.update({
    id: '/hr/salaries/my-payslips',
    path: '/hr/salaries/my-payslips',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrLeavesStatisticsRoute =
  AuthenticatedHrLeavesStatisticsRouteImport.update({
    id: '/hr/leaves/statistics',
    path: '/hr/leaves/statistics',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrLeavesPendingRoute =
  AuthenticatedHrLeavesPendingRouteImport.update({
    id: '/hr/leaves/pending',
    path: '/hr/leaves/pending',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHrEmployeesEmployeeIdRoute =
  AuthenticatedHrEmployeesEmployeeIdRouteImport.update({
    id: '/hr/employees/$employeeId',
    path: '/hr/employees/$employeeId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmTeamsTeamIdIndexRoute =
  AuthenticatedPmTeamsTeamIdIndexRouteImport.update({
    id: '/pm/teams/$teamId/',
    path: '/pm/teams/$teamId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsProjectIdIndexRoute =
  AuthenticatedPmProjectsProjectIdIndexRouteImport.update({
    id: '/pm/projects/$projectId/',
    path: '/pm/projects/$projectId/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsProjectIdMilestonesRoute =
  AuthenticatedPmProjectsProjectIdMilestonesRouteImport.update({
    id: '/pm/projects/$projectId/milestones',
    path: '/pm/projects/$projectId/milestones',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsProjectIdMembersRoute =
  AuthenticatedPmProjectsProjectIdMembersRouteImport.update({
    id: '/pm/projects/$projectId/members',
    path: '/pm/projects/$projectId/members',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsProjectIdGanttRoute =
  AuthenticatedPmProjectsProjectIdGanttRouteImport.update({
    id: '/pm/projects/$projectId/gantt',
    path: '/pm/projects/$projectId/gantt',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPmProjectsProjectIdBoardRoute =
  AuthenticatedPmProjectsProjectIdBoardRouteImport.update({
    id: '/pm/projects/$projectId/board',
    path: '/pm/projects/$projectId/board',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/finance/currencies': typeof AuthenticatedFinanceCurrenciesRoute
  '/finance/transfers': typeof AuthenticatedFinanceTransfersRoute
  '/knowledge-base/search': typeof AuthenticatedKnowledgeBaseSearchRoute
  '/my/devices': typeof AuthenticatedMyDevicesRoute
  '/pm/my-stage-tasks': typeof AuthenticatedPmMyStageTasksRoute
  '/pm/my-tasks': typeof AuthenticatedPmMyTasksRoute
  '/pm/my-workflow-tasks': typeof AuthenticatedPmMyWorkflowTasksRoute
  '/pm/workflow-analytics': typeof AuthenticatedPmWorkflowAnalyticsRoute
  '/pm/workload-stats': typeof AuthenticatedPmWorkloadStatsRoute
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/settings/config': typeof AuthenticatedSettingsConfigRoute
  '/settings/efficiency': typeof AuthenticatedSettingsEfficiencyRoute
  '/settings/my-notifications': typeof AuthenticatedSettingsMyNotificationsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/finance': typeof AuthenticatedFinanceIndexRoute
  '/knowledge-base': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/organization': typeof AuthenticatedOrganizationIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/hr/employees/$employeeId': typeof AuthenticatedHrEmployeesEmployeeIdRoute
  '/hr/leaves/pending': typeof AuthenticatedHrLeavesPendingRoute
  '/hr/leaves/statistics': typeof AuthenticatedHrLeavesStatisticsRoute
  '/hr/salaries/my-payslips': typeof AuthenticatedHrSalariesMyPayslipsRoute
  '/hr/salaries/payslips': typeof AuthenticatedHrSalariesPayslipsRoute
  '/knowledge-base/documents/$documentId': typeof AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute
  '/knowledge-base/spaces/$spaceId': typeof AuthenticatedKnowledgeBaseSpacesSpaceIdRoute
  '/pm/issues/$issueId': typeof AuthenticatedPmIssuesIssueIdRoute
  '/pm/projects/new': typeof AuthenticatedPmProjectsNewRoute
  '/admin/devices': typeof AuthenticatedAdminDevicesIndexRoute
  '/finance/accounts': typeof AuthenticatedFinanceAccountsIndexRoute
  '/finance/cash-flows': typeof AuthenticatedFinanceCashFlowsIndexRoute
  '/finance/categories': typeof AuthenticatedFinanceCategoriesIndexRoute
  '/finance/reimbursements': typeof AuthenticatedFinanceReimbursementsIndexRoute
  '/hr/departments': typeof AuthenticatedHrDepartmentsIndexRoute
  '/hr/employees': typeof AuthenticatedHrEmployeesIndexRoute
  '/hr/leaves': typeof AuthenticatedHrLeavesIndexRoute
  '/hr/positions': typeof AuthenticatedHrPositionsIndexRoute
  '/hr/salaries': typeof AuthenticatedHrSalariesIndexRoute
  '/pm/issues': typeof AuthenticatedPmIssuesIndexRoute
  '/pm/projects': typeof AuthenticatedPmProjectsIndexRoute
  '/pm/teams': typeof AuthenticatedPmTeamsIndexRoute
  '/pm/timelogs': typeof AuthenticatedPmTimelogsIndexRoute
  '/pm/projects/$projectId/board': typeof AuthenticatedPmProjectsProjectIdBoardRoute
  '/pm/projects/$projectId/gantt': typeof AuthenticatedPmProjectsProjectIdGanttRoute
  '/pm/projects/$projectId/members': typeof AuthenticatedPmProjectsProjectIdMembersRoute
  '/pm/projects/$projectId/milestones': typeof AuthenticatedPmProjectsProjectIdMilestonesRoute
  '/pm/projects/$projectId': typeof AuthenticatedPmProjectsProjectIdIndexRoute
  '/pm/teams/$teamId': typeof AuthenticatedPmTeamsTeamIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/finance/currencies': typeof AuthenticatedFinanceCurrenciesRoute
  '/finance/transfers': typeof AuthenticatedFinanceTransfersRoute
  '/knowledge-base/search': typeof AuthenticatedKnowledgeBaseSearchRoute
  '/my/devices': typeof AuthenticatedMyDevicesRoute
  '/pm/my-stage-tasks': typeof AuthenticatedPmMyStageTasksRoute
  '/pm/my-tasks': typeof AuthenticatedPmMyTasksRoute
  '/pm/my-workflow-tasks': typeof AuthenticatedPmMyWorkflowTasksRoute
  '/pm/workflow-analytics': typeof AuthenticatedPmWorkflowAnalyticsRoute
  '/pm/workload-stats': typeof AuthenticatedPmWorkloadStatsRoute
  '/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/settings/config': typeof AuthenticatedSettingsConfigRoute
  '/settings/efficiency': typeof AuthenticatedSettingsEfficiencyRoute
  '/settings/my-notifications': typeof AuthenticatedSettingsMyNotificationsRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/finance': typeof AuthenticatedFinanceIndexRoute
  '/knowledge-base': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/notifications': typeof AuthenticatedNotificationsIndexRoute
  '/organization': typeof AuthenticatedOrganizationIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/hr/employees/$employeeId': typeof AuthenticatedHrEmployeesEmployeeIdRoute
  '/hr/leaves/pending': typeof AuthenticatedHrLeavesPendingRoute
  '/hr/leaves/statistics': typeof AuthenticatedHrLeavesStatisticsRoute
  '/hr/salaries/my-payslips': typeof AuthenticatedHrSalariesMyPayslipsRoute
  '/hr/salaries/payslips': typeof AuthenticatedHrSalariesPayslipsRoute
  '/knowledge-base/documents/$documentId': typeof AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute
  '/knowledge-base/spaces/$spaceId': typeof AuthenticatedKnowledgeBaseSpacesSpaceIdRoute
  '/pm/issues/$issueId': typeof AuthenticatedPmIssuesIssueIdRoute
  '/pm/projects/new': typeof AuthenticatedPmProjectsNewRoute
  '/admin/devices': typeof AuthenticatedAdminDevicesIndexRoute
  '/finance/accounts': typeof AuthenticatedFinanceAccountsIndexRoute
  '/finance/cash-flows': typeof AuthenticatedFinanceCashFlowsIndexRoute
  '/finance/categories': typeof AuthenticatedFinanceCategoriesIndexRoute
  '/finance/reimbursements': typeof AuthenticatedFinanceReimbursementsIndexRoute
  '/hr/departments': typeof AuthenticatedHrDepartmentsIndexRoute
  '/hr/employees': typeof AuthenticatedHrEmployeesIndexRoute
  '/hr/leaves': typeof AuthenticatedHrLeavesIndexRoute
  '/hr/positions': typeof AuthenticatedHrPositionsIndexRoute
  '/hr/salaries': typeof AuthenticatedHrSalariesIndexRoute
  '/pm/issues': typeof AuthenticatedPmIssuesIndexRoute
  '/pm/projects': typeof AuthenticatedPmProjectsIndexRoute
  '/pm/teams': typeof AuthenticatedPmTeamsIndexRoute
  '/pm/timelogs': typeof AuthenticatedPmTimelogsIndexRoute
  '/pm/projects/$projectId/board': typeof AuthenticatedPmProjectsProjectIdBoardRoute
  '/pm/projects/$projectId/gantt': typeof AuthenticatedPmProjectsProjectIdGanttRoute
  '/pm/projects/$projectId/members': typeof AuthenticatedPmProjectsProjectIdMembersRoute
  '/pm/projects/$projectId/milestones': typeof AuthenticatedPmProjectsProjectIdMilestonesRoute
  '/pm/projects/$projectId': typeof AuthenticatedPmProjectsProjectIdIndexRoute
  '/pm/teams/$teamId': typeof AuthenticatedPmTeamsTeamIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/_authenticated/finance/currencies': typeof AuthenticatedFinanceCurrenciesRoute
  '/_authenticated/finance/transfers': typeof AuthenticatedFinanceTransfersRoute
  '/_authenticated/knowledge-base/search': typeof AuthenticatedKnowledgeBaseSearchRoute
  '/_authenticated/my/devices': typeof AuthenticatedMyDevicesRoute
  '/_authenticated/pm/my-stage-tasks': typeof AuthenticatedPmMyStageTasksRoute
  '/_authenticated/pm/my-tasks': typeof AuthenticatedPmMyTasksRoute
  '/_authenticated/pm/my-workflow-tasks': typeof AuthenticatedPmMyWorkflowTasksRoute
  '/_authenticated/pm/workflow-analytics': typeof AuthenticatedPmWorkflowAnalyticsRoute
  '/_authenticated/pm/workload-stats': typeof AuthenticatedPmWorkloadStatsRoute
  '/_authenticated/settings/audit-logs': typeof AuthenticatedSettingsAuditLogsRoute
  '/_authenticated/settings/config': typeof AuthenticatedSettingsConfigRoute
  '/_authenticated/settings/efficiency': typeof AuthenticatedSettingsEfficiencyRoute
  '/_authenticated/settings/my-notifications': typeof AuthenticatedSettingsMyNotificationsRoute
  '/_authenticated/settings/notifications': typeof AuthenticatedSettingsNotificationsRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/finance/': typeof AuthenticatedFinanceIndexRoute
  '/_authenticated/knowledge-base/': typeof AuthenticatedKnowledgeBaseIndexRoute
  '/_authenticated/notifications/': typeof AuthenticatedNotificationsIndexRoute
  '/_authenticated/organization/': typeof AuthenticatedOrganizationIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/hr/employees/$employeeId': typeof AuthenticatedHrEmployeesEmployeeIdRoute
  '/_authenticated/hr/leaves/pending': typeof AuthenticatedHrLeavesPendingRoute
  '/_authenticated/hr/leaves/statistics': typeof AuthenticatedHrLeavesStatisticsRoute
  '/_authenticated/hr/salaries/my-payslips': typeof AuthenticatedHrSalariesMyPayslipsRoute
  '/_authenticated/hr/salaries/payslips': typeof AuthenticatedHrSalariesPayslipsRoute
  '/_authenticated/knowledge-base/documents/$documentId': typeof AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute
  '/_authenticated/knowledge-base/spaces/$spaceId': typeof AuthenticatedKnowledgeBaseSpacesSpaceIdRoute
  '/_authenticated/pm/issues/$issueId': typeof AuthenticatedPmIssuesIssueIdRoute
  '/_authenticated/pm/projects/new': typeof AuthenticatedPmProjectsNewRoute
  '/_authenticated/admin/devices/': typeof AuthenticatedAdminDevicesIndexRoute
  '/_authenticated/finance/accounts/': typeof AuthenticatedFinanceAccountsIndexRoute
  '/_authenticated/finance/cash-flows/': typeof AuthenticatedFinanceCashFlowsIndexRoute
  '/_authenticated/finance/categories/': typeof AuthenticatedFinanceCategoriesIndexRoute
  '/_authenticated/finance/reimbursements/': typeof AuthenticatedFinanceReimbursementsIndexRoute
  '/_authenticated/hr/departments/': typeof AuthenticatedHrDepartmentsIndexRoute
  '/_authenticated/hr/employees/': typeof AuthenticatedHrEmployeesIndexRoute
  '/_authenticated/hr/leaves/': typeof AuthenticatedHrLeavesIndexRoute
  '/_authenticated/hr/positions/': typeof AuthenticatedHrPositionsIndexRoute
  '/_authenticated/hr/salaries/': typeof AuthenticatedHrSalariesIndexRoute
  '/_authenticated/pm/issues/': typeof AuthenticatedPmIssuesIndexRoute
  '/_authenticated/pm/projects/': typeof AuthenticatedPmProjectsIndexRoute
  '/_authenticated/pm/teams/': typeof AuthenticatedPmTeamsIndexRoute
  '/_authenticated/pm/timelogs/': typeof AuthenticatedPmTimelogsIndexRoute
  '/_authenticated/pm/projects/$projectId/board': typeof AuthenticatedPmProjectsProjectIdBoardRoute
  '/_authenticated/pm/projects/$projectId/gantt': typeof AuthenticatedPmProjectsProjectIdGanttRoute
  '/_authenticated/pm/projects/$projectId/members': typeof AuthenticatedPmProjectsProjectIdMembersRoute
  '/_authenticated/pm/projects/$projectId/milestones': typeof AuthenticatedPmProjectsProjectIdMilestonesRoute
  '/_authenticated/pm/projects/$projectId/': typeof AuthenticatedPmProjectsProjectIdIndexRoute
  '/_authenticated/pm/teams/$teamId/': typeof AuthenticatedPmTeamsTeamIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/finance/currencies'
    | '/finance/transfers'
    | '/knowledge-base/search'
    | '/my/devices'
    | '/pm/my-stage-tasks'
    | '/pm/my-tasks'
    | '/pm/my-workflow-tasks'
    | '/pm/workflow-analytics'
    | '/pm/workload-stats'
    | '/settings/audit-logs'
    | '/settings/config'
    | '/settings/efficiency'
    | '/settings/my-notifications'
    | '/settings/notifications'
    | '/settings/profile'
    | '/finance'
    | '/knowledge-base'
    | '/notifications'
    | '/organization'
    | '/settings'
    | '/hr/employees/$employeeId'
    | '/hr/leaves/pending'
    | '/hr/leaves/statistics'
    | '/hr/salaries/my-payslips'
    | '/hr/salaries/payslips'
    | '/knowledge-base/documents/$documentId'
    | '/knowledge-base/spaces/$spaceId'
    | '/pm/issues/$issueId'
    | '/pm/projects/new'
    | '/admin/devices'
    | '/finance/accounts'
    | '/finance/cash-flows'
    | '/finance/categories'
    | '/finance/reimbursements'
    | '/hr/departments'
    | '/hr/employees'
    | '/hr/leaves'
    | '/hr/positions'
    | '/hr/salaries'
    | '/pm/issues'
    | '/pm/projects'
    | '/pm/teams'
    | '/pm/timelogs'
    | '/pm/projects/$projectId/board'
    | '/pm/projects/$projectId/gantt'
    | '/pm/projects/$projectId/members'
    | '/pm/projects/$projectId/milestones'
    | '/pm/projects/$projectId'
    | '/pm/teams/$teamId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/finance/currencies'
    | '/finance/transfers'
    | '/knowledge-base/search'
    | '/my/devices'
    | '/pm/my-stage-tasks'
    | '/pm/my-tasks'
    | '/pm/my-workflow-tasks'
    | '/pm/workflow-analytics'
    | '/pm/workload-stats'
    | '/settings/audit-logs'
    | '/settings/config'
    | '/settings/efficiency'
    | '/settings/my-notifications'
    | '/settings/notifications'
    | '/settings/profile'
    | '/finance'
    | '/knowledge-base'
    | '/notifications'
    | '/organization'
    | '/settings'
    | '/hr/employees/$employeeId'
    | '/hr/leaves/pending'
    | '/hr/leaves/statistics'
    | '/hr/salaries/my-payslips'
    | '/hr/salaries/payslips'
    | '/knowledge-base/documents/$documentId'
    | '/knowledge-base/spaces/$spaceId'
    | '/pm/issues/$issueId'
    | '/pm/projects/new'
    | '/admin/devices'
    | '/finance/accounts'
    | '/finance/cash-flows'
    | '/finance/categories'
    | '/finance/reimbursements'
    | '/hr/departments'
    | '/hr/employees'
    | '/hr/leaves'
    | '/hr/positions'
    | '/hr/salaries'
    | '/pm/issues'
    | '/pm/projects'
    | '/pm/teams'
    | '/pm/timelogs'
    | '/pm/projects/$projectId/board'
    | '/pm/projects/$projectId/gantt'
    | '/pm/projects/$projectId/members'
    | '/pm/projects/$projectId/milestones'
    | '/pm/projects/$projectId'
    | '/pm/teams/$teamId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/_authenticated/dashboard'
    | '/_authenticated/finance/currencies'
    | '/_authenticated/finance/transfers'
    | '/_authenticated/knowledge-base/search'
    | '/_authenticated/my/devices'
    | '/_authenticated/pm/my-stage-tasks'
    | '/_authenticated/pm/my-tasks'
    | '/_authenticated/pm/my-workflow-tasks'
    | '/_authenticated/pm/workflow-analytics'
    | '/_authenticated/pm/workload-stats'
    | '/_authenticated/settings/audit-logs'
    | '/_authenticated/settings/config'
    | '/_authenticated/settings/efficiency'
    | '/_authenticated/settings/my-notifications'
    | '/_authenticated/settings/notifications'
    | '/_authenticated/settings/profile'
    | '/_authenticated/finance/'
    | '/_authenticated/knowledge-base/'
    | '/_authenticated/notifications/'
    | '/_authenticated/organization/'
    | '/_authenticated/settings/'
    | '/_authenticated/hr/employees/$employeeId'
    | '/_authenticated/hr/leaves/pending'
    | '/_authenticated/hr/leaves/statistics'
    | '/_authenticated/hr/salaries/my-payslips'
    | '/_authenticated/hr/salaries/payslips'
    | '/_authenticated/knowledge-base/documents/$documentId'
    | '/_authenticated/knowledge-base/spaces/$spaceId'
    | '/_authenticated/pm/issues/$issueId'
    | '/_authenticated/pm/projects/new'
    | '/_authenticated/admin/devices/'
    | '/_authenticated/finance/accounts/'
    | '/_authenticated/finance/cash-flows/'
    | '/_authenticated/finance/categories/'
    | '/_authenticated/finance/reimbursements/'
    | '/_authenticated/hr/departments/'
    | '/_authenticated/hr/employees/'
    | '/_authenticated/hr/leaves/'
    | '/_authenticated/hr/positions/'
    | '/_authenticated/hr/salaries/'
    | '/_authenticated/pm/issues/'
    | '/_authenticated/pm/projects/'
    | '/_authenticated/pm/teams/'
    | '/_authenticated/pm/timelogs/'
    | '/_authenticated/pm/projects/$projectId/board'
    | '/_authenticated/pm/projects/$projectId/gantt'
    | '/_authenticated/pm/projects/$projectId/members'
    | '/_authenticated/pm/projects/$projectId/milestones'
    | '/_authenticated/pm/projects/$projectId/'
    | '/_authenticated/pm/teams/$teamId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/organization/': {
      id: '/_authenticated/organization/'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof AuthenticatedOrganizationIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications/': {
      id: '/_authenticated/notifications/'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/': {
      id: '/_authenticated/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/knowledge-base'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/': {
      id: '/_authenticated/finance/'
      path: '/finance'
      fullPath: '/finance'
      preLoaderRoute: typeof AuthenticatedFinanceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/notifications': {
      id: '/_authenticated/settings/notifications'
      path: '/settings/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/my-notifications': {
      id: '/_authenticated/settings/my-notifications'
      path: '/settings/my-notifications'
      fullPath: '/settings/my-notifications'
      preLoaderRoute: typeof AuthenticatedSettingsMyNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/efficiency': {
      id: '/_authenticated/settings/efficiency'
      path: '/settings/efficiency'
      fullPath: '/settings/efficiency'
      preLoaderRoute: typeof AuthenticatedSettingsEfficiencyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/config': {
      id: '/_authenticated/settings/config'
      path: '/settings/config'
      fullPath: '/settings/config'
      preLoaderRoute: typeof AuthenticatedSettingsConfigRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings/audit-logs': {
      id: '/_authenticated/settings/audit-logs'
      path: '/settings/audit-logs'
      fullPath: '/settings/audit-logs'
      preLoaderRoute: typeof AuthenticatedSettingsAuditLogsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/workload-stats': {
      id: '/_authenticated/pm/workload-stats'
      path: '/pm/workload-stats'
      fullPath: '/pm/workload-stats'
      preLoaderRoute: typeof AuthenticatedPmWorkloadStatsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/workflow-analytics': {
      id: '/_authenticated/pm/workflow-analytics'
      path: '/pm/workflow-analytics'
      fullPath: '/pm/workflow-analytics'
      preLoaderRoute: typeof AuthenticatedPmWorkflowAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/my-workflow-tasks': {
      id: '/_authenticated/pm/my-workflow-tasks'
      path: '/pm/my-workflow-tasks'
      fullPath: '/pm/my-workflow-tasks'
      preLoaderRoute: typeof AuthenticatedPmMyWorkflowTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/my-tasks': {
      id: '/_authenticated/pm/my-tasks'
      path: '/pm/my-tasks'
      fullPath: '/pm/my-tasks'
      preLoaderRoute: typeof AuthenticatedPmMyTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/my-stage-tasks': {
      id: '/_authenticated/pm/my-stage-tasks'
      path: '/pm/my-stage-tasks'
      fullPath: '/pm/my-stage-tasks'
      preLoaderRoute: typeof AuthenticatedPmMyStageTasksRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my/devices': {
      id: '/_authenticated/my/devices'
      path: '/my/devices'
      fullPath: '/my/devices'
      preLoaderRoute: typeof AuthenticatedMyDevicesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/search': {
      id: '/_authenticated/knowledge-base/search'
      path: '/knowledge-base/search'
      fullPath: '/knowledge-base/search'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseSearchRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/transfers': {
      id: '/_authenticated/finance/transfers'
      path: '/finance/transfers'
      fullPath: '/finance/transfers'
      preLoaderRoute: typeof AuthenticatedFinanceTransfersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/currencies': {
      id: '/_authenticated/finance/currencies'
      path: '/finance/currencies'
      fullPath: '/finance/currencies'
      preLoaderRoute: typeof AuthenticatedFinanceCurrenciesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/timelogs/': {
      id: '/_authenticated/pm/timelogs/'
      path: '/pm/timelogs'
      fullPath: '/pm/timelogs'
      preLoaderRoute: typeof AuthenticatedPmTimelogsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/teams/': {
      id: '/_authenticated/pm/teams/'
      path: '/pm/teams'
      fullPath: '/pm/teams'
      preLoaderRoute: typeof AuthenticatedPmTeamsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/': {
      id: '/_authenticated/pm/projects/'
      path: '/pm/projects'
      fullPath: '/pm/projects'
      preLoaderRoute: typeof AuthenticatedPmProjectsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/issues/': {
      id: '/_authenticated/pm/issues/'
      path: '/pm/issues'
      fullPath: '/pm/issues'
      preLoaderRoute: typeof AuthenticatedPmIssuesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/salaries/': {
      id: '/_authenticated/hr/salaries/'
      path: '/hr/salaries'
      fullPath: '/hr/salaries'
      preLoaderRoute: typeof AuthenticatedHrSalariesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/positions/': {
      id: '/_authenticated/hr/positions/'
      path: '/hr/positions'
      fullPath: '/hr/positions'
      preLoaderRoute: typeof AuthenticatedHrPositionsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/leaves/': {
      id: '/_authenticated/hr/leaves/'
      path: '/hr/leaves'
      fullPath: '/hr/leaves'
      preLoaderRoute: typeof AuthenticatedHrLeavesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/employees/': {
      id: '/_authenticated/hr/employees/'
      path: '/hr/employees'
      fullPath: '/hr/employees'
      preLoaderRoute: typeof AuthenticatedHrEmployeesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/departments/': {
      id: '/_authenticated/hr/departments/'
      path: '/hr/departments'
      fullPath: '/hr/departments'
      preLoaderRoute: typeof AuthenticatedHrDepartmentsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/reimbursements/': {
      id: '/_authenticated/finance/reimbursements/'
      path: '/finance/reimbursements'
      fullPath: '/finance/reimbursements'
      preLoaderRoute: typeof AuthenticatedFinanceReimbursementsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/categories/': {
      id: '/_authenticated/finance/categories/'
      path: '/finance/categories'
      fullPath: '/finance/categories'
      preLoaderRoute: typeof AuthenticatedFinanceCategoriesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/cash-flows/': {
      id: '/_authenticated/finance/cash-flows/'
      path: '/finance/cash-flows'
      fullPath: '/finance/cash-flows'
      preLoaderRoute: typeof AuthenticatedFinanceCashFlowsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/finance/accounts/': {
      id: '/_authenticated/finance/accounts/'
      path: '/finance/accounts'
      fullPath: '/finance/accounts'
      preLoaderRoute: typeof AuthenticatedFinanceAccountsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/admin/devices/': {
      id: '/_authenticated/admin/devices/'
      path: '/admin/devices'
      fullPath: '/admin/devices'
      preLoaderRoute: typeof AuthenticatedAdminDevicesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/new': {
      id: '/_authenticated/pm/projects/new'
      path: '/pm/projects/new'
      fullPath: '/pm/projects/new'
      preLoaderRoute: typeof AuthenticatedPmProjectsNewRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/issues/$issueId': {
      id: '/_authenticated/pm/issues/$issueId'
      path: '/pm/issues/$issueId'
      fullPath: '/pm/issues/$issueId'
      preLoaderRoute: typeof AuthenticatedPmIssuesIssueIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/spaces/$spaceId': {
      id: '/_authenticated/knowledge-base/spaces/$spaceId'
      path: '/knowledge-base/spaces/$spaceId'
      fullPath: '/knowledge-base/spaces/$spaceId'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseSpacesSpaceIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-base/documents/$documentId': {
      id: '/_authenticated/knowledge-base/documents/$documentId'
      path: '/knowledge-base/documents/$documentId'
      fullPath: '/knowledge-base/documents/$documentId'
      preLoaderRoute: typeof AuthenticatedKnowledgeBaseDocumentsDocumentIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/salaries/payslips': {
      id: '/_authenticated/hr/salaries/payslips'
      path: '/hr/salaries/payslips'
      fullPath: '/hr/salaries/payslips'
      preLoaderRoute: typeof AuthenticatedHrSalariesPayslipsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/salaries/my-payslips': {
      id: '/_authenticated/hr/salaries/my-payslips'
      path: '/hr/salaries/my-payslips'
      fullPath: '/hr/salaries/my-payslips'
      preLoaderRoute: typeof AuthenticatedHrSalariesMyPayslipsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/leaves/statistics': {
      id: '/_authenticated/hr/leaves/statistics'
      path: '/hr/leaves/statistics'
      fullPath: '/hr/leaves/statistics'
      preLoaderRoute: typeof AuthenticatedHrLeavesStatisticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/leaves/pending': {
      id: '/_authenticated/hr/leaves/pending'
      path: '/hr/leaves/pending'
      fullPath: '/hr/leaves/pending'
      preLoaderRoute: typeof AuthenticatedHrLeavesPendingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/hr/employees/$employeeId': {
      id: '/_authenticated/hr/employees/$employeeId'
      path: '/hr/employees/$employeeId'
      fullPath: '/hr/employees/$employeeId'
      preLoaderRoute: typeof AuthenticatedHrEmployeesEmployeeIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/teams/$teamId/': {
      id: '/_authenticated/pm/teams/$teamId/'
      path: '/pm/teams/$teamId'
      fullPath: '/pm/teams/$teamId'
      preLoaderRoute: typeof AuthenticatedPmTeamsTeamIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/$projectId/': {
      id: '/_authenticated/pm/projects/$projectId/'
      path: '/pm/projects/$projectId'
      fullPath: '/pm/projects/$projectId'
      preLoaderRoute: typeof AuthenticatedPmProjectsProjectIdIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/$projectId/milestones': {
      id: '/_authenticated/pm/projects/$projectId/milestones'
      path: '/pm/projects/$projectId/milestones'
      fullPath: '/pm/projects/$projectId/milestones'
      preLoaderRoute: typeof AuthenticatedPmProjectsProjectIdMilestonesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/$projectId/members': {
      id: '/_authenticated/pm/projects/$projectId/members'
      path: '/pm/projects/$projectId/members'
      fullPath: '/pm/projects/$projectId/members'
      preLoaderRoute: typeof AuthenticatedPmProjectsProjectIdMembersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/$projectId/gantt': {
      id: '/_authenticated/pm/projects/$projectId/gantt'
      path: '/pm/projects/$projectId/gantt'
      fullPath: '/pm/projects/$projectId/gantt'
      preLoaderRoute: typeof AuthenticatedPmProjectsProjectIdGanttRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/pm/projects/$projectId/board': {
      id: '/_authenticated/pm/projects/$projectId/board'
      path: '/pm/projects/$projectId/board'
      fullPath: '/pm/projects/$projectId/board'
      preLoaderRoute: typeof AuthenticatedPmProjectsProjectIdBoardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
  AuthenticatedFinanceCurrenciesRoute: typeof AuthenticatedFinanceCurrenciesRoute
  AuthenticatedFinanceTransfersRoute: typeof AuthenticatedFinanceTransfersRoute
  AuthenticatedKnowledgeBaseSearchRoute: typeof AuthenticatedKnowledgeBaseSearchRoute
  AuthenticatedMyDevicesRoute: typeof AuthenticatedMyDevicesRoute
  AuthenticatedPmMyStageTasksRoute: typeof AuthenticatedPmMyStageTasksRoute
  AuthenticatedPmMyTasksRoute: typeof AuthenticatedPmMyTasksRoute
  AuthenticatedPmMyWorkflowTasksRoute: typeof AuthenticatedPmMyWorkflowTasksRoute
  AuthenticatedPmWorkflowAnalyticsRoute: typeof AuthenticatedPmWorkflowAnalyticsRoute
  AuthenticatedPmWorkloadStatsRoute: typeof AuthenticatedPmWorkloadStatsRoute
  AuthenticatedSettingsAuditLogsRoute: typeof AuthenticatedSettingsAuditLogsRoute
  AuthenticatedSettingsConfigRoute: typeof AuthenticatedSettingsConfigRoute
  AuthenticatedSettingsEfficiencyRoute: typeof AuthenticatedSettingsEfficiencyRoute
  AuthenticatedSettingsMyNotificationsRoute: typeof AuthenticatedSettingsMyNotificationsRoute
  AuthenticatedSettingsNotificationsRoute: typeof AuthenticatedSettingsNotificationsRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedFinanceIndexRoute: typeof AuthenticatedFinanceIndexRoute
  AuthenticatedKnowledgeBaseIndexRoute: typeof AuthenticatedKnowledgeBaseIndexRoute
  AuthenticatedNotificationsIndexRoute: typeof AuthenticatedNotificationsIndexRoute
  AuthenticatedOrganizationIndexRoute: typeof AuthenticatedOrganizationIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedHrEmployeesEmployeeIdRoute: typeof AuthenticatedHrEmployeesEmployeeIdRoute
  AuthenticatedHrLeavesPendingRoute: typeof AuthenticatedHrLeavesPendingRoute
  AuthenticatedHrLeavesStatisticsRoute: typeof AuthenticatedHrLeavesStatisticsRoute
  AuthenticatedHrSalariesMyPayslipsRoute: typeof AuthenticatedHrSalariesMyPayslipsRoute
  AuthenticatedHrSalariesPayslipsRoute: typeof AuthenticatedHrSalariesPayslipsRoute
  AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute: typeof AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute
  AuthenticatedKnowledgeBaseSpacesSpaceIdRoute: typeof AuthenticatedKnowledgeBaseSpacesSpaceIdRoute
  AuthenticatedPmIssuesIssueIdRoute: typeof AuthenticatedPmIssuesIssueIdRoute
  AuthenticatedPmProjectsNewRoute: typeof AuthenticatedPmProjectsNewRoute
  AuthenticatedAdminDevicesIndexRoute: typeof AuthenticatedAdminDevicesIndexRoute
  AuthenticatedFinanceAccountsIndexRoute: typeof AuthenticatedFinanceAccountsIndexRoute
  AuthenticatedFinanceCashFlowsIndexRoute: typeof AuthenticatedFinanceCashFlowsIndexRoute
  AuthenticatedFinanceCategoriesIndexRoute: typeof AuthenticatedFinanceCategoriesIndexRoute
  AuthenticatedFinanceReimbursementsIndexRoute: typeof AuthenticatedFinanceReimbursementsIndexRoute
  AuthenticatedHrDepartmentsIndexRoute: typeof AuthenticatedHrDepartmentsIndexRoute
  AuthenticatedHrEmployeesIndexRoute: typeof AuthenticatedHrEmployeesIndexRoute
  AuthenticatedHrLeavesIndexRoute: typeof AuthenticatedHrLeavesIndexRoute
  AuthenticatedHrPositionsIndexRoute: typeof AuthenticatedHrPositionsIndexRoute
  AuthenticatedHrSalariesIndexRoute: typeof AuthenticatedHrSalariesIndexRoute
  AuthenticatedPmIssuesIndexRoute: typeof AuthenticatedPmIssuesIndexRoute
  AuthenticatedPmProjectsIndexRoute: typeof AuthenticatedPmProjectsIndexRoute
  AuthenticatedPmTeamsIndexRoute: typeof AuthenticatedPmTeamsIndexRoute
  AuthenticatedPmTimelogsIndexRoute: typeof AuthenticatedPmTimelogsIndexRoute
  AuthenticatedPmProjectsProjectIdBoardRoute: typeof AuthenticatedPmProjectsProjectIdBoardRoute
  AuthenticatedPmProjectsProjectIdGanttRoute: typeof AuthenticatedPmProjectsProjectIdGanttRoute
  AuthenticatedPmProjectsProjectIdMembersRoute: typeof AuthenticatedPmProjectsProjectIdMembersRoute
  AuthenticatedPmProjectsProjectIdMilestonesRoute: typeof AuthenticatedPmProjectsProjectIdMilestonesRoute
  AuthenticatedPmProjectsProjectIdIndexRoute: typeof AuthenticatedPmProjectsProjectIdIndexRoute
  AuthenticatedPmTeamsTeamIdIndexRoute: typeof AuthenticatedPmTeamsTeamIdIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
  AuthenticatedFinanceCurrenciesRoute: AuthenticatedFinanceCurrenciesRoute,
  AuthenticatedFinanceTransfersRoute: AuthenticatedFinanceTransfersRoute,
  AuthenticatedKnowledgeBaseSearchRoute: AuthenticatedKnowledgeBaseSearchRoute,
  AuthenticatedMyDevicesRoute: AuthenticatedMyDevicesRoute,
  AuthenticatedPmMyStageTasksRoute: AuthenticatedPmMyStageTasksRoute,
  AuthenticatedPmMyTasksRoute: AuthenticatedPmMyTasksRoute,
  AuthenticatedPmMyWorkflowTasksRoute: AuthenticatedPmMyWorkflowTasksRoute,
  AuthenticatedPmWorkflowAnalyticsRoute: AuthenticatedPmWorkflowAnalyticsRoute,
  AuthenticatedPmWorkloadStatsRoute: AuthenticatedPmWorkloadStatsRoute,
  AuthenticatedSettingsAuditLogsRoute: AuthenticatedSettingsAuditLogsRoute,
  AuthenticatedSettingsConfigRoute: AuthenticatedSettingsConfigRoute,
  AuthenticatedSettingsEfficiencyRoute: AuthenticatedSettingsEfficiencyRoute,
  AuthenticatedSettingsMyNotificationsRoute:
    AuthenticatedSettingsMyNotificationsRoute,
  AuthenticatedSettingsNotificationsRoute:
    AuthenticatedSettingsNotificationsRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedFinanceIndexRoute: AuthenticatedFinanceIndexRoute,
  AuthenticatedKnowledgeBaseIndexRoute: AuthenticatedKnowledgeBaseIndexRoute,
  AuthenticatedNotificationsIndexRoute: AuthenticatedNotificationsIndexRoute,
  AuthenticatedOrganizationIndexRoute: AuthenticatedOrganizationIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedHrEmployeesEmployeeIdRoute:
    AuthenticatedHrEmployeesEmployeeIdRoute,
  AuthenticatedHrLeavesPendingRoute: AuthenticatedHrLeavesPendingRoute,
  AuthenticatedHrLeavesStatisticsRoute: AuthenticatedHrLeavesStatisticsRoute,
  AuthenticatedHrSalariesMyPayslipsRoute:
    AuthenticatedHrSalariesMyPayslipsRoute,
  AuthenticatedHrSalariesPayslipsRoute: AuthenticatedHrSalariesPayslipsRoute,
  AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute:
    AuthenticatedKnowledgeBaseDocumentsDocumentIdRoute,
  AuthenticatedKnowledgeBaseSpacesSpaceIdRoute:
    AuthenticatedKnowledgeBaseSpacesSpaceIdRoute,
  AuthenticatedPmIssuesIssueIdRoute: AuthenticatedPmIssuesIssueIdRoute,
  AuthenticatedPmProjectsNewRoute: AuthenticatedPmProjectsNewRoute,
  AuthenticatedAdminDevicesIndexRoute: AuthenticatedAdminDevicesIndexRoute,
  AuthenticatedFinanceAccountsIndexRoute:
    AuthenticatedFinanceAccountsIndexRoute,
  AuthenticatedFinanceCashFlowsIndexRoute:
    AuthenticatedFinanceCashFlowsIndexRoute,
  AuthenticatedFinanceCategoriesIndexRoute:
    AuthenticatedFinanceCategoriesIndexRoute,
  AuthenticatedFinanceReimbursementsIndexRoute:
    AuthenticatedFinanceReimbursementsIndexRoute,
  AuthenticatedHrDepartmentsIndexRoute: AuthenticatedHrDepartmentsIndexRoute,
  AuthenticatedHrEmployeesIndexRoute: AuthenticatedHrEmployeesIndexRoute,
  AuthenticatedHrLeavesIndexRoute: AuthenticatedHrLeavesIndexRoute,
  AuthenticatedHrPositionsIndexRoute: AuthenticatedHrPositionsIndexRoute,
  AuthenticatedHrSalariesIndexRoute: AuthenticatedHrSalariesIndexRoute,
  AuthenticatedPmIssuesIndexRoute: AuthenticatedPmIssuesIndexRoute,
  AuthenticatedPmProjectsIndexRoute: AuthenticatedPmProjectsIndexRoute,
  AuthenticatedPmTeamsIndexRoute: AuthenticatedPmTeamsIndexRoute,
  AuthenticatedPmTimelogsIndexRoute: AuthenticatedPmTimelogsIndexRoute,
  AuthenticatedPmProjectsProjectIdBoardRoute:
    AuthenticatedPmProjectsProjectIdBoardRoute,
  AuthenticatedPmProjectsProjectIdGanttRoute:
    AuthenticatedPmProjectsProjectIdGanttRoute,
  AuthenticatedPmProjectsProjectIdMembersRoute:
    AuthenticatedPmProjectsProjectIdMembersRoute,
  AuthenticatedPmProjectsProjectIdMilestonesRoute:
    AuthenticatedPmProjectsProjectIdMilestonesRoute,
  AuthenticatedPmProjectsProjectIdIndexRoute:
    AuthenticatedPmProjectsProjectIdIndexRoute,
  AuthenticatedPmTeamsTeamIdIndexRoute: AuthenticatedPmTeamsTeamIdIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
